/**
 * Who can trigger activity notifications for recipients.
 * - OwnerOnly: only the file owner's actions generate notifications to recipients.
 * - Anyone: any user's actions (including other recipients) generate notifications.
 */
export enum FileAccessNotificationSettingTriggerEnum {
  OwnerOnly = 'ownerOnly',
  Anyone = 'anyone',
}
